"use client"

import { motion } from "framer-motion"
import { useRouter } from "next/navigation"

export function Hero() {
  const router = useRouter()

  return (
    <section className="relative flex min-h-svh flex-col items-center justify-center px-6">
      <div className="relative z-10 mx-auto max-w-3xl text-center">
        <motion.h1
          className="font-[var(--font-instrument-serif)] text-5xl font-normal leading-tight tracking-tight sm:text-6xl md:text-7xl"
          style={{ color: "var(--brand-graphite)" }}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
        >
          Your Mind &mdash; Illuminated
        </motion.h1>

        <motion.p
          className="mt-6 font-[var(--font-instrument-serif)] text-lg sm:text-xl"
          style={{ color: "var(--brand-cliff)" }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4, ease: "easeOut" }}
        >
          A map of your soul, drawn from the conversations you&apos;ve already had.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.55, ease: "easeOut" }}
        >
          <button
            onClick={() => router.push("/upload")}
            className="btn-star mt-10 inline-block rounded-full px-8 py-3 text-sm"
          >
            See Your Mind
          </button>
        </motion.div>

        <motion.p
          className="mt-4 text-sm"
          style={{ color: "var(--brand-cliff)" }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 1.0, ease: "easeOut" }}
        >
          Instant preview &middot; No account needed
        </motion.p>
      </div>
    </section>
  )
}
